import React from 'react'
import { getImages } from '../Components/const'
import { image } from 'framer-motion/client'
import ProductQuantityInput from '../Components/ProductDetails/ProductQuantityInput'
import { Link } from 'react-router-dom'
import ProductSlider from '../Components/ProductDetails/ProductSlider'
import SeoMeta from '../Components/Common/SeoMeta'

const boutiqueData = [
    {
        image: 'rb-image1.png',
        title: 'New Era x McLaren Flawless 9Forty Cap - Anthracite',
        price: '$39.99',
    },
    {
        image: 'rb-image2.png',
        title: 'McLaren Formula 1 Team Speedmark Keyring',
        price: '$19.99',
    },
    {
        image: 'rb-image3.png',
        title: 'McLaren Formula 1 Team Speedmark Keyring',
        price: '$19.99',
    },
    {
        image: 'rb-image4.png',
        title: 'McLaren Formula 1 Team Speedmark Keyring',
        price: '$19.99',
    },
]
const ProductDetails = () => {
    return (
        <>
            <SeoMeta
                title={"K-Swiss x McLaren Mens Slide Sandals" + "  | Official McLaren Orlando Shop"}
                description="Shop official McLaren merchandise, apparel, accessories, and gifts at McLaren Orlando. Explore premium products inspired by the McLaren lifestyle."
                keywords=""
                ogTitle={"K-Swiss x McLaren Mens Slide Sandals" + "  | Official McLaren Orlando Shop"}
                ogDescription="Shop official McLaren merchandise, apparel, accessories, and gifts at McLaren Orlando. Explore premium products inspired by the McLaren lifestyle."
            />
            <section className='product-dtl-wrap'>
                <div className='dtl-top'>
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='xs-title me-4'><img className='me-1' src={getImages('mcl-icon.png')} /> Shopping Bag</div>
                            <div>
                                <img className='me-2' src={getImages('bag-icon.png')} />
                                <span className='bag-count xs-title'>2</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='product-dtl-block'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                {/* <div className='product-box'>
                                    <img src={getImages('pic.png')} alt='product' />
                                </div> */}
                                <ProductSlider/>
                            </div>
                            <div className='col-lg-6 mt-lg-0 mt-5'>
                                <div className='product-info'>
                                    <h4 className='xs-title text-uppercase text-orange mb-4'>Boutique</h4>
                                    <h1 className='md-title font-1-5em mb-3'>K-Swiss x McLaren Mens Slide Sandals</h1>
                                    <div className='lg-title fw-bold'>$89.99</div>
                                    <p>Now available in two bold and contrasting liveries, the 2025 Slide Sandal x McLaren is your go-to footwear for giving your feet a much-needed break after a thrilling day at the track or simply lounging poolside in between races.</p>
                                    <div className='row mt-4 justify-content-between'>
                                        <div className='col-xxl-5 col-lg-6 col-md-7 col-sm-6 mb-md-0 mb-4'>
                                            <div className='pi-label'>Size</div>
                                            <select className='form-control pi-form-control'>
                                                <option>Select</option>
                                                <option>L</option>
                                                <option>M</option>
                                                <option>S</option>
                                                <option>XS</option>
                                            </select>
                                        </div>
                                        <div className='col-xxl-5 col-lg-6 col-sm-6 col-md-5'>
                                            <div className='pi-label'>Quantity</div>
                                            <ProductQuantityInput />
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center justify-content-between mt-60'>
                                        <div>
                                            <div className='xs-title font-0-9em text-uppercase'>100 Reviews</div>
                                            <div>
                                                <img className='me-1' src={getImages('yellow-star-on.png')} />
                                                <img className='me-1' src={getImages('yellow-star-on.png')} />
                                                <img className='me-1' src={getImages('yellow-star-on.png')} />
                                                <img className='me-1' src={getImages('yellow-star-on.png')} />
                                                <img className='me-1' src={getImages('yellow-star-off.png')} />
                                            </div>
                                        </div>
                                        <div>
                                            <button type='button' className='theme-btn text-uppercase d-inline-block reveal wow fadeIn'>Add to Cart</button>
                                        </div>
                                    </div>
                                    <div className='xs-title font-0-9em opacity-0-75 mt-70'><strong>Categories:</strong>&nbsp; Clothing, Accesories, Footwear</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='pi-tabs-block'>
                    <div className='container'>
                        <div className='product-tabs'>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button className="nav-link active" id="nav-description-tab" data-bs-toggle="tab" data-bs-target="#nav-description" type="button" role="tab" aria-controls="nav-description" aria-selected="true">Description</button>
                                    <button className="nav-link" id="nav-reviews-tab" data-bs-toggle="tab" data-bs-target="#nav-reviews" type="button" role="tab" aria-controls="nav-reviews" aria-selected="false">Reviews</button>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-description" role="tabpanel" aria-labelledby="nav-description-tab" tabIndex="0">
                                    <p>Now available in two bold and contrasting liveries, the 2025 Slide Sandal x McLaren is your go-to footwear for giving your feet a much-needed break after a thrilling day at the track or simply lounging poolside in between races. The footbed is anatomically contoured to offer increased underfoot comfort, while the wide and padded strap secures the foot in place. Simply perfect to kick back in McLaren-approved comfort.</p>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa.</p>
                                </div>
                                <div className="tab-pane fade" id="nav-reviews" role="tabpanel" aria-labelledby="nav-reviews-tab" tabIndex="0">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='recommended-block'>
                    <div className='container'>
                        <div className='lg-title font-1-9em text-uppercase'>Recommended Items</div>
                        <div className='row mt-4'>
                            {boutiqueData?.map((product, index) => (
                                <div className='col-lg-3 col-md-6 col-sm-6 mb-lg-0 mb-3' key={index}>
                                    <div className='product-box'>
                                        <div className='product-image'>
                                            <img src={getImages(product.image)} alt='product' />
                                        </div>
                                        <div className='product-content'>
                                            <div className='product-title'>{product.title}</div>
                                            <div className='product-price mt-2'>{product.price}</div>
                                            <div className='text-center mt-3'>
                                                <a href='#' className='product-btn'>Quick View</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProductDetails